// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"fa53810d","513":"9091e77f","703":"9350a9ff"}[chunkId] + ".chunk.js";
};